import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
} from '@mui/material';
import { Clock, MapPin } from 'lucide-react';
import { BookingModal } from './components/BookingModal';
import { useBookingStore } from './store/bookingStore';

const restaurantHours = [
  { day: 'Monday', open: '10:00', close: '22:00', isOpen: true },
  { day: 'Tuesday', open: '10:00', close: '22:00', isOpen: true },
  { day: 'Wednesday', open: '10:00', close: '22:00', isOpen: true },
  { day: 'Thursday', open: '10:00', close: '22:00', isOpen: true },
  { day: 'Friday', open: '10:00', close: '23:00', isOpen: true },
  { day: 'Saturday', open: '10:00', close: '23:00', isOpen: true },
  { day: 'Sunday', open: '11:00', close: '22:00', isOpen: true },
];

const CustomerDashboard: React.FC = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const { bookings, cancelBooking } = useBookingStore();

  const handleOpenBookingModal = () => {
    setIsBookingModalOpen(true);
  };

  const handleCloseBookingModal = () => {
    setIsBookingModalOpen(false);
  };

  return (
    <div className="p-6">
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h4" gutterBottom>
                Welcome to Our Restaurant
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleOpenBookingModal}
                sx={{ mt: 2 }}
              >
                Book a Table
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                <Clock className="inline-block mr-2" />
                Opening Hours
              </Typography>
              <List>
                {restaurantHours.map((schedule) => (
                  <ListItem key={schedule.day}>
                    <ListItemText
                      primary={schedule.day}
                      secondary={`${schedule.open} - ${schedule.close}`}
                    />
                    <Chip
                      label={schedule.isOpen ? 'Open' : 'Closed'}
                      color={schedule.isOpen ? 'success' : 'error'}
                      size="small"
                    />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                <MapPin className="inline-block mr-2" />
                Location & Contact
              </Typography>
              <Typography variant="body1" paragraph>
                123 Restaurant Street
                <br />
                City, State 12345
              </Typography>
              <Typography variant="body1">
                Phone: (555) 123-4567
                <br />
                Email: info@restaurant.com
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Your Bookings
              </Typography>
              <List>
                {bookings.map((booking) => (
                  <ListItem
                    key={booking.id}
                    secondaryAction={
                      booking.status === 'pending' && (
                        <Button
                          onClick={() => cancelBooking(booking.id)}
                          color="error"
                        >
                          Cancel
                        </Button>
                      )
                    }
                  >
                    <ListItemText
                      primary={`${booking.customerName} - ${booking.date}`}
                      secondary={`Time: ${booking.timeSlots.join(
                        ', '
                      )} | Status: ${booking.status}`}
                    />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <BookingModal
        open={isBookingModalOpen}
        onClose={handleCloseBookingModal}
      />
    </div>
  );
};

export default CustomerDashboard;
